<script>
    import Mobilebtn2 from '../mobilebtn2.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let img;
    let main;
    let title;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {scale: 1, duration: 1},
                {scale: 1.5, duration: 1, y: -200},
            ],
            3,
        );
        initializeGsapAnimation(
            main,
            title,
            [
                {top: '25vw', duration: 1},
                {top: '-25vw', duration: 1},
            ],
            3,
        );
    }
</script>

<div class="gamerWrraper" bind:this={main}>
    <div class="heading1" bind:this={title}>
        <p>
            ARTISTS <span style="font-weight: 400;">&</span>
        </p>
        <p>MUSICIANS</p>
    </div>
    <div class="imageWrraper" bind:this={img}>
        <img
            src="/images/colorful.png"
            alt="colorFull"
            width="100%"
            height="auto"
        />
    </div>
    <div class="text">
        <p>
            A future that expands your 2D canvas infinitely into a
                    multidimensional multiverse. And for the first time, the
                    canvas can almost keep up with your imagination.

                    Unleash your talent on this canvas to bring entire worlds
                    into existence and make your fantasy real.
        </p>
    </div>
    <div class="btn">
        <a href="/artist">
            <Mobilebtn2
            popup = false
            bgcolor="transparent"
            text="Learn More"
            width="23.364vw"
            height="7.477vw"
            txtcolor="black"
            border="black"
            textPadding = '0vw'
        />
        </a>
        
    </div>
</div>

<style>
    .gamerWrraper {
        width: 100vw;
        overflow: hidden;
        position: relative;
        font-family: "Orbitron";
        background-color: #59e7f2;
        height: max(216.355vw, 100vh);
    }
    p {
        margin: 0;
        font-family: "Orbitron";
    }
    .heading1 {

        color: black;
        font-weight: 900;
        position: absolute;
        left: max(1.168vw, 0.54vh);
        font-size: max(11.682vw, 5.4vh);
        top: 15vw;
        z-index: 1;
    }
    .heading1 p:nth-child(2) {
        margin-left: max(10.2vw, 4.204vh);
    }
    .imageWrraper {
        left: 0;
        width: 104.956vw;
        position: relative;
        transform: scale(0.5);
        transform-origin: center;
        top: max(29.888vw, 9.898vh);
        height: max(130.808vw, 53.065vh);
    }
    .text {
        width: 81.963vw;
        position: absolute;
        left: max(8.879vw, 4.104vh);
        bottom: max(23.474vw, 10.799vh);
    }
    .text p {
        font-weight: 400;
        color: black;
        line-height:3.925vw;
        font-size: 3.271vw;
        letter-spacing: 0.06em;
    }
    .btn {
        position: absolute;
        left: max(8.178vw, 3.78vh);
        bottom: max(9.346vw, 4.32vh);
    }
</style>
